const en_us = {
    values: {
        Contracts: 'Contracts',
        Well: 'Well',
        Wellbore: 'Well',
        Activity: 'Activity',
        Planned: 'Planned',
        Projects: 'Projects',

        'Description': 'Description',
        'Name': 'Name',
        'Quantity': 'Quantity',
        'UOM': 'UOM',
        'Status': 'Status',
        'Loading...': 'Loading...',
        'New Attribute': 'New Attribute',
        'Edit Attribute': 'Edit Attribute',
        'Attribute Created Successfully!': 'Attribute Created Successfully!',
        'Attribute Edited Successfully!': 'Attribute Edited Successfully!'
    }
}

module.exports = en_us
